import { useOnboardingWizard } from '@epi-shared/hooks/useOnboardingWizard';
import config from '@epi-config';

const { enableNewBenefitGroups } = config;

const useOnboarding = () => {
  const { isOnBoardingActive, isSuccess, flags } = useOnboardingWizard();

  const benefitGroupNotExists =
    enableNewBenefitGroups &&
    isOnBoardingActive &&
    isSuccess &&
    !flags?.isBenefitsSet;

  return { benefitGroupNotExists };
};

export { useOnboarding };
